import withAttachCardDialog from 'components/hoc/withAttachCardDialog';
import Banner from 'components/system/Banner';

const AttachCardBanner = ({ openAttachCard }) => (
  <Banner
    announcement="Attach billing!"
    note="You won't be charged now*"
    callForAction="Add a card"
    actionHandler={openAttachCard}
  />
);

export default withAttachCardDialog(AttachCardBanner);
